import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailablePhoneNumberModel, DataViewEnum, ColumnModel, SearchPhoneNumberFilterModel, AvailablePhoneNumberDataModel
} from '../models';
import { RootState } from '../app/store';
import { setFormattedData, addOrUpdateData } from '../helpers/helper';

export interface BuyNumberState {
    dataView: DataViewEnum;
    filters: SearchPhoneNumberFilterModel;
    data: AvailablePhoneNumberDataModel;
}

const initialState: BuyNumberState = {
    dataView: DataViewEnum.List,

    filters: {
        countryCode: "GB",
        locality: ""
    },
    data: {
        recordCount: 0,
        records: [],
        rawData: [],
        columns: []
    },
};

const uniqueDataKey = "friendlyName";

const columnConfig: Record<string, Partial<ColumnModel>> = {
    friendlyName: {
        flexGrow: 1
    },
    phoneNumber: {
        flexGrow: 1
    },
    isoCountry: {
        flexGrow: 1
    },
    voice: {
        flexGrow: 1,
        formatter: (record: AvailablePhoneNumberModel) => record.capabilities.voice
    },
    sms: {
        flexGrow: 1,
        formatter: (record: AvailablePhoneNumberModel) => record.capabilities.sms
    }
};

export const buyNumberSlice = createSlice({
    name: 'buyNumber',
    initialState,
    reducers: {
        setBuyData: (state, action: PayloadAction<AvailablePhoneNumberModel[]>) => {
            state.data = setFormattedData({ rawData: action.payload }, columnConfig, uniqueDataKey);
        },
        setFilters: (state, action: PayloadAction<SearchPhoneNumberFilterModel>) => {
            state.filters = action.payload;
            return state;
        },
        setLogoutBuyNumbers: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { setBuyData, setFilters, setLogoutBuyNumbers } = buyNumberSlice.actions;

export default buyNumberSlice.reducer;